import { useAuthenticator } from '@aws-amplify/ui-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { triggerLogout } from '../../utils/authSync';
import { getActiveFleetId, getLastOpenedFleetId, setActiveFleetId } from '../../utils/fleetStorage';
import useGetRole from './useGetRole';

function useGetFleetId(): string {
  const [searchParams] = useSearchParams();
  if (searchParams.get('fleetId')) {
    setActiveFleetId(searchParams.get('fleetId') || '');
  }

  const { user } = useAuthenticator();
  const { isAdmin } = useGetRole();
  // system admins can switch fleets, so the fleet they opened last
  // becomes the active one after the next login
  const lastOpenedFleetId = isAdmin ? getLastOpenedFleetId(user.attributes?.email || '') : '';
  const fleetId = getActiveFleetId() || lastOpenedFleetId || user.attributes?.['custom:fleetId'] || '';

  useEffect(() => {
    if (user && !fleetId) {
      console.info('No fleet Id');
      triggerLogout({ broadcast: false });
    }
  }, [user, fleetId]);

  return fleetId;
}

export default useGetFleetId;
